<template>
  <div>
    <!-- Create Account Dialog -->
    <createAccountDialog />
    <!-- Login Dialog -->
    <loginDialog />
    <!-- Forgot Password Dialog -->
    <forgotPasswordDialog />
    <slot></slot>
  </div>
</template>

<script>
  import loginDialog from '@/components/authentication/LoginDialog.vue';
  import createAccountDialog from '@/components/authentication/CreateAccountDialog.vue';
  import forgotPasswordDialog from '@/components/authentication/ForgotPasswordDialog.vue';

  export default {
    components: {
      loginDialog,
      createAccountDialog,
      forgotPasswordDialog
    }
  };
</script>
